import React from 'react'
import { Helmet } from 'react-helmet-async'
import { InvoicesLayout } from '../../layouts/Billing'

const InvoicesPage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Invoices</title>
      <meta name="description" content="Invoices page" />
    </Helmet>
    <InvoicesLayout />
  </React.Fragment>
)

export default InvoicesPage
